import React from "react";
import "../styles/Home.css";

const Home = () => {
  return (
    <div className="Home">
      <h1 className="UkanaHeader">Ukana</h1>
      <h1 className="UkanaHeaderJp">言う仮名</h1>
      <h3 className="Subheader">Your place for Japanese language-learning!</h3>
      <h3 className="SubheaderStart">
        Click on a link above to get started. 始めましょう！
      </h3>
    </div>
  );
};

export default Home;
